import { rpc } from '@server/infrastructure/rpc'

import { getBearerToken } from '../../authentication'

export type UpdateProfileBody = {
  name: string
  phone?: string
  gender?: 'M' | 'F'
  otp?: string
  /** 인증을 마친 새 계정 이메일. 미변경이면 보내지 않는다. */
  email?: string
}

export const updateProfile = async (body: UpdateProfileBody, bearerToken?: string) => {
  const authorizationToken = bearerToken ?? (await getBearerToken())
  const response = await rpc.api.v1.users.profile.$put(
    { json: body },
    { headers: { Authorization: `Bearer ${authorizationToken}` } },
  )

  if (!response.ok) {
    throw new Error(`Failed to update profile: ${response.status}`)
  }
}
